import { instance } from "../axios/axiosConfig";
import {
  MediaPlanBodyDataType,
  CampaignByIdEditBodyType,
  CampaignByIdEditDataType,
} from "../types/campaignsTypes.tsx";

const campaignsApi = {
  fetchCampaignsData(params: string) {
    return instance.get(`/api/campaigns-view/`, { params });
  },
  fetchCampaignByIdData(id: string) {
    return instance.get(`/api/campaigns-view/${id}/`);
  },
  editCampaignByIdData(data: CampaignByIdEditDataType) {
    return instance.patch(`/api/campaigns-view/${data.id}/`, data.body);
  },
  deleteCampaignByIdData(id: string) {
    return instance.delete(`/api/campaigns-view/${id}/`);
  },
  createCampaign(body: CampaignByIdEditBodyType) {
    return instance.post(`/api/campaigns-view/`, body);
  },
  fetchInitialRecommendation() {
    return instance.get(`/api/initial-recommendation/`);
  },
  fetchMediaPlanData(data: MediaPlanBodyDataType) {
    return instance.get(`/api/campaigns/${data.id}/media-plan/`, {
      params: data.params,
    });
  },
};

export default campaignsApi;
